import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useWorkWithUs } from "contexts/WorkWithUs.contexts";

const useContact = () => {
    const { t: translate } = useTranslation();
    const {
        dataFields,
        errors,
        updateDataField,
        updateErrors,
        updateStatusError,
    } = useWorkWithUs();

    const handleChangeText = useCallback(
        ({ target }, item) => {
            updateDataField(item, {
                ...{ ...dataFields[item], [target.name]: target.value },
            });

            updateErrors(item, {
                ...{ ...errors[item], [target.name]: false },
            });
            updateStatusError(false);
        },
        [dataFields, errors, updateDataField, updateErrors, updateStatusError]
    );


    const origemContatoList = [
        { value: "Site Grupo Altum", label: "Site Grupo Altum" },
        { value: "Site Adservi", label: "Site Adservi" },
        { value: "Site Master Vigilância", label: "Site Master Vigilância" },
        { value: "Site Grupo Liberdade", label: "Site Grupo Liberdade" },
        { value: "Site 5 Estrelas", label: "Site 5 Estrelas" },
        { value: "Site Tecnoseg", label: "Site Tecnoseg" },
        { value: "Linkedin", label: "Linkedin" },
        { value: "Facebook", label: "Facebook" },
        { value: "Instagram", label: "Instagram" },
        { value: "Whatsapp", label: "WhatsApp" },
        { value: "Indicação", label: "Indicação" },
        { value: "Outros", label: "Outros" },
    ];

    const getOptionsGender = [
        {
            label: translate("workWithUs.form.step3.genderOptions.masculine"),
            value: "Masculino",
        },
        {
            label: translate("workWithUs.form.step3.genderOptions.feminine"),
            value: "Feminino",
        },
    ];

    return {
        origemContatoList,
        getOptionsGender,
        dataFields,
        errors,
        translate,
        handleChangeText,

    };
};

export default useContact;
